import { lazyForPaint } from 'react-loosely-lazy';
import { withAsync } from '@atlassian/help-center-common-component/with-async';

const loader = lazyForPaint(() => import(/* webpackChunkName: "request-details" */ './request-details-stateless'));

export default withAsync({ loader });
